import { createStyles, makeUiStyles, Theme } from '../../styles/styles';
import { CardHeaderProps } from './tools/CardHeader.model';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    padding: ({layout}:CardHeaderProps) => layout === 'flat' ?  '32px 0 32px' : '32px 40px 36px',
    marginLeft: ({layout}:CardHeaderProps) => layout === 'flat' ?  0 : -40,
    marginRight: ({layout}:CardHeaderProps) => layout === 'flat' ?  0 : -40,
    marginTop: -32,
    backgroundColor: ({layout}:CardHeaderProps) => layout === 'flat' ?  theme.color.greys[10] : theme.color.greys[0],

    [theme.breakpoints.down('xs')]: {
      padding: `16px ${theme.space.appPadding}px 20px`,
      marginLeft: -theme.space.appPadding,
      marginRight: -theme.space.appPadding,
      marginTop: -16,
    }
  }
}), { name: 'CardHeader', index: StylesIndexInjections.UI_ATOMS });
